import React from 'react';
import { bool, node, string } from 'prop-types';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { AssistantOrchestrator } from '../orchestrator/AssistantOrchestrator';
// Direct path, not the journeys barrel: this module is in the warm-while-closed chunk.
import { useResolvedJourney } from '../journeys/useResolvedJourney';

// Composition boundary: resolve the ACTIVE journey, then mount the orchestrator; stays
// mounted while closed. See .claude/context/journey-resolution.md.
export const AssistantDataProvider = ({ children, journeyId = 'assistant', withDataLayer = false }) => {
  // Resolve BEFORE mounting the orchestrator: every journeyId holds on isResolving, so no
  // block is ever mounted then torn down. See .claude/context/journey-resolution.md.
  const { journey, isResolving } = useResolvedJourney(journeyId);

  return (
    <ErrorBoundary name="magic-apron-assistant-composition-root">
      {!isResolving && (
        <AssistantOrchestrator
          flows={journey.flows}
          config={journey.config}
          withDataLayer={withDataLayer}
        >
          {children}
        </AssistantOrchestrator>
      )}
    </ErrorBoundary>
  );
};

AssistantDataProvider.propTypes = {
  children: node,
  // Already normalized against the registry by App via resolveJourneyId.
  journeyId: string,
  // App's latch: true from the first drawer-open onward.
  withDataLayer: bool,
};
